module.exports = "/_next/static/media/8f2effaba8fb2e3e6b492bf31dfbd9f7.svg";